import LaunchIcon from '@mui/icons-material/Launch';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import type { SxProps } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import type { Deal } from '@openx/types/deal';
import { Link } from 'react-router';

type Props = {
  deal: Pick<Deal, 'id' | 'uid' | 'name'>;
  sx?: SxProps;
};

export const GroupDealRboAlert = ({ deal, sx = {} }: Props) => (
  <Box
    data-test="group-deal-rbo-alert"
    sx={[
      {
        maxWidth: 550,
      },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  >
    <Alert severity="info">
      <Typography data-test="alert-message">This configuration is inherited from the following deal:</Typography>

      <Link data-test="alert-link" to={`/deals/${deal.uid}`} target="_blank">
        <Typography component="span">
          <Typography
            variant="body1Bold"
            component="span"
            sx={{
              color: 'primary.main',
            }}
          >
            {deal.name}
          </Typography>{' '}
          <Typography
            component="span"
            sx={{
              color: 'text.primary',
              fontWeight: 'fontWeightRegular',
            }}
          >
            (ID: {deal.id})
          </Typography>
        </Typography>{' '}
        <IconButton aria-label="Deal RBO alert button" sx={{ ml: -0.5 }}>
          <LaunchIcon data-test="launch-icon" />
        </IconButton>
      </Link>
    </Alert>
  </Box>
);
